import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { BehaviorSubject, debounceTime, distinctUntilChanged, skip } from 'rxjs'
import { slideInOutAnimation } from 'libs/shared/utils/animations/src'

@UntilDestroy()
@Component({
  selector: 'gb-item-search',
  templateUrl: './gb-item-search.component.html',
  styleUrls: ['./gb-item-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [slideInOutAnimation],
})
export class GbItemSearchComponent implements OnInit {
  @Input() searchTerm = ''
  @Input() alwaysVisible = false
  @Input() placeholder = 'ITEM_SEARCH.PLACEHOLDER'
  @Output() searchChange = new EventEmitter<string>()
  searchVisible = false

  private searchTermSubject$ = new BehaviorSubject<string>(this.searchTerm)

  ngOnInit(): void {
    this.searchTermSubject$
      .pipe(debounceTime(500), skip(1), distinctUntilChanged(), untilDestroyed(this))
      .subscribe((searchTerm) => {
        this.searchChange.emit(searchTerm)
      })
    // show search box if initial search term value or search always visible
    this.searchVisible = !!this.searchTerm || this.alwaysVisible
  }

  onSearchChange(): void {
    this.searchTermSubject$.next(this.searchTerm)
  }

  onClear(): void {
    this.searchTerm = ''
    this.onSearchChange()
  }

  toggleSearch(): void {
    this.searchVisible = !this.searchVisible
  }

  /**
   * Hide search box on blur if no input and search not always visible
   */
  hideSearch(): void {
    if (this.alwaysVisible) return
    if (!this.searchTerm) this.searchVisible = false
  }
}
